/** Coordinates app generations and idempotent teardown across route changes. */
export class AppLifecycle {
  private generation = 0;
  private teardownCurrent: () => void = () => {};

  /** Dispose the active app and mark the next async startup as the current generation. */
  begin(): number {
    this.dispose();
    this.generation += 1;
    return this.generation;
  }

  /** Invalidate pending startup work and dispose the active app (e.g. navigating home). */
  invalidate(): void {
    this.dispose();
    this.generation += 1;
  }

  isCurrent(generation: number): boolean {
    return generation === this.generation;
  }

  registerTeardown(teardown: () => void): void {
    this.teardownCurrent = teardown;
  }

  dispose(): void {
    const teardown = this.teardownCurrent;
    this.teardownCurrent = () => {};
    teardown();
  }
}
